import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const FileDropZone = ({ onDrop }) => {
    const onDropCallback = useCallback((acceptedFiles) => {
        if (acceptedFiles.length > 1) {
            alert("Only one file is allowed");
            return;
        }
        onDrop(acceptedFiles);
    }, [onDrop]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: onDropCallback,
        multiple: false,
        accept: 'image/*,application/pdf', // Accepts images and PDFs; customize as needed
    });

    return (
        <div {...getRootProps()} className={"dropzone"}>
            <input {...getInputProps()} />
            {isDragActive ? (
                <p>Drop the file here...</p>
            ) : (
                <p>Drag 'n' drop a file here, or click to select a file</p>
            )}
        </div>
    );
};

export default FileDropZone;